import React, {forwardRef} from 'react';
import {Form, Row, Input, TimePicker, Col, Checkbox} from 'antd';
import {VideoFileTitrationType, VideoFileTitrationTypeOptions, VideoFileTtitration} from "../../models/video-file";
import {FormattedMessage} from "react-intl";
import moment from "moment-jalaali";
import clsx from "clsx";
import {useImperativeHandle} from "react";


interface TitrationProps {
  type: VideoFileTitrationType,
  start_time: string,
  end_time: string
}


class Titration extends React.Component<TitrationProps> {
  constructor(props) {
    super(props);
    this.state = {
      active: props.titration ? true : false,
      titration: props.titration
    }
  }
  
  getValue = () => {
    if(this.state.active){
      let returnValues = null;
  
      this.props.form.setFieldsValue({
        "start_time": this.state.titration.start_time ? this.state.titration.start_time : null,
        "end_time": this.state.titration.end_time ? this.state.titration.end_time : null,
      });
  
      this.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          returnValues = {
            ...values,
            video_file_titrations_type : this.props.type
          }
      
        } else {
          console.log(err)
        }
      });
  
      return returnValues;
    }
    else{
      return false;
    }
  };
  
  onChange = (event) => {
    this.setState({
      active: event.target.checked
    })
  };
  
  onChangeTime = (key, value) => {
    this.setState({
      titration: {
        ...this.state.titration,
        [key]: value.format("HH:mm:ss")
      }
    })
  };
  
  render() {
    const {form, type} = this.props;
    const {getFieldDecorator} = form;
    const { active, titration={}} = this.state;
    
    return (
      <Form className={'titration-item'}>
        <Checkbox onChange={this.onChange} checked={active}>
          {VideoFileTitrationTypeOptions.find(opt => opt.value === type).label}
        </Checkbox>
        
        <Row gutter={24} className={clsx({
          "collapsed": !active
        })}>
          <Col span={12}>
            <Form.Item label={<FormattedMessage id="app.start_time" defaultMessage={`Start Time`}/>}>
              {getFieldDecorator("start_time", {
                rules: [{
                  // whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.start_time_is_required"
                                             defaultMessage={`Start time is required!`}/>
                }]
              })(<Input type={'hidden'}/>)}
              <TimePicker placeholder={''}
                          value={moment(titration.start_time, 'HH:mm:ss')}
                          onChange={value => this.onChangeTime("start_time", value)}/>
            </Form.Item>
          </Col>
          
          <Col span={12}>
            <Form.Item label={<FormattedMessage id="app.end_time" defaultMessage={`End Time`}/>}>
              {getFieldDecorator("end_time", {
                rules: [{
                  // whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.end_time_is_required"
                                             defaultMessage={`End time is required!`}/>
                }]
              })(<Input type={'hidden'}/>)}
              <TimePicker placeholder={''}
                          value={moment(titration.end_time, 'HH:mm:ss')}
                          onChange={value => this.onChangeTime("end_time", value)}/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

const TitrationForm = Form.create({name: "titration-form"})(Titration);





/**
 * Titration manager
 * Handles start and end titration
 * return null means that there is an error in titration forms
 * return an empty array is valid and means that the video file doe snot have any titration
 * and if there start or end titration returns array on object
 * @param props
 * @param ref
 * @constructor
 */


interface TitrationManagerProps {
  titrations: VideoFileTtitration,
}



function TitrationManager(props: TitrationManagerProps, ref) {
  const {titrations = []} = props;
  let formRefs = {};
  
  useImperativeHandle(ref, () => ({
    getValue: () => {
      const titrations = [];
      
      for (const key in formRefs){
        const titration = formRefs[key].getValue();
        if(titration !== false){
          titrations.push( titration )
        }
      }
      
      return (titrations.map( item => item !== null ).length == titrations.length) ? titrations : null
    }
  }));
  
  const setTitrationFormsRefs = (titrationType, formRef) => {
    formRefs = {
      ...formRefs,
      [titrationType]: formRef
    }
  };
  
  return (
    <div>
      <TitrationForm wrappedComponentRef={ref => setTitrationFormsRefs("start", ref)}
                     type={VideoFileTitrationType.START}
                     titration={titrations.find( opt => opt.video_file_titrations_type === VideoFileTitrationType.START)}/>
      
      <TitrationForm wrappedComponentRef={ref => setTitrationFormsRefs("end", ref)}
                     type={VideoFileTitrationType.END}
                     titration={titrations.find( opt => opt.video_file_titrations_type === VideoFileTitrationType.END)}/>
    </div>
  )
  
}

export default forwardRef(TitrationManager);